import React, { useState } from 'react';
import { Filter, X } from 'lucide-react';

export interface FilterOption {
    id: string;
    label: string;
    icon?: string;
}

interface ComparisonFilterProps {
    options: FilterOption[];
    onFilterChange: (selectedFilters: string[]) => void;
    title?: string;
}

const ComparisonFilter: React.FC<ComparisonFilterProps> = ({
    options,
    onFilterChange,
    title = "Filtrar por benefício"
}) => {
    const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
    const [isOpen, setIsOpen] = useState(true);

    const toggleFilter = (filterId: string) => {
        const newFilters = selectedFilters.includes(filterId)
            ? selectedFilters.filter(f => f !== filterId)
            : [...selectedFilters, filterId];

        setSelectedFilters(newFilters);
        onFilterChange(newFilters);
    };

    const clearFilters = () => {
        setSelectedFilters([]);
        onFilterChange([]);
    };

    return (
        <div className="my-8 bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="w-full px-6 py-4 flex items-center justify-between bg-gradient-to-r from-indigo-50 to-purple-50 hover:from-indigo-100 hover:to-purple-100 transition-colors"
            >
                <div className="flex items-center gap-3">
                    <div className="p-2 bg-indigo-600 rounded-lg">
                        <Filter className="w-5 h-5 text-white" />
                    </div>
                    <h3 className="text-lg font-bold text-indigo-900">{title}</h3>
                    {selectedFilters.length > 0 && (
                        <span className="px-2 py-1 bg-indigo-600 text-white text-xs rounded-full">
                            {selectedFilters.length} selecionado{selectedFilters.length > 1 ? 's' : ''}
                        </span>
                    )}
                </div>
            </button>

            {isOpen && (
                <div className="p-6">
                    <div className="flex flex-wrap gap-3">
                        {options.map((option) => {
                            const isSelected = selectedFilters.includes(option.id);
                            return (
                                <button
                                    key={option.id}
                                    onClick={() => toggleFilter(option.id)}
                                    className={`flex items-center gap-2 px-4 py-2 rounded-full border-2 transition-all duration-200 ${isSelected
                                            ? 'border-indigo-600 bg-indigo-600 text-white'
                                            : 'border-gray-200 bg-white text-gray-700 hover:border-indigo-300 hover:bg-indigo-50'
                                        }`}
                                >
                                    {option.icon && <span>{option.icon}</span>}
                                    <span className="font-medium">{option.label}</span>
                                </button>
                            );
                        })}
                    </div>

                    {selectedFilters.length > 0 && (
                        <button
                            onClick={clearFilters}
                            className="mt-4 flex items-center gap-2 text-sm text-gray-500 hover:text-red-600 transition-colors"
                        >
                            <X className="w-4 h-4" />
                            Limpar filtros
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

export default ComparisonFilter;
